import { render, staticRenderFns } from "./responsive.vue?vue&type=template&id=468f6984&"
import script from "./responsive.vue?vue&type=script&lang=js&"
export * from "./responsive.vue?vue&type=script&lang=js&"
import style0 from "./responsive.vue?vue&type=style&index=0&id=468f6984&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports